module.exports = __webpack_public_path__ + "img/icon-500.a81bc55.svg";